module.exports = __webpack_public_path__ + "step3.6d86f034.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/old steps/step3.png
// module id = /jj9
// module chunks = 0